import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee2a91c0")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("button", {
    class: [{
      [_ctx.buttonClass]: true,
      'mobile-collapse': _ctx.mobileCollapse,
    }, "button"]
  }, [
    (_ctx.iconLeft)
      ? (_openBlock(), _createBlock("i", {
          key: 0,
          class: [_ctx.leftClasses, "fas left"]
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.iconRight)
      ? (_openBlock(), _createBlock("i", {
          key: 1,
          class: [_ctx.rightClasses, "fas right"]
        }, null, 2))
      : _createCommentVNode("", true)
  ], 2))
})